import {useState} from "react";

import {
  DropdownAction,
  DropdownActionItem,
  DropdownItem,
  DropDownReactLink,
} from "@/components/quickActionsBar/DropdownAction.tsx";
import {DropdownDivider} from "@/components/quickActionsBar/DropdownDivider.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {MaintenanceScheduleListItem} from "@/lib/types/maintenance.ts";
import {MaintenanceDelete} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/actions/MaintenanceDelete.tsx";
import {
  MaintenancePauseConfirmation,
  useMaintenancePauseResume,
} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/actions/MaintenancePauseResumeButton.tsx";
import {getNextOccurrence} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/MaintenanceSchedulesTable.utils.ts";

type MaintenanceSchedulesTableActionsProps = {
  schedule: MaintenanceScheduleListItem;
};

export const MaintenanceSchedulesTableActions = ({schedule}: MaintenanceSchedulesTableActionsProps) => {
  const nextOccurrence = getNextOccurrence(schedule);
  const [showDelete, setShowDelete] = useState(false);
  const [showPauseConfirm, setShowPauseConfirm] = useState(false);
  const {resumeSchedule} = useMaintenancePauseResume(schedule);

  const actionsBarItems: DropdownItem[] = [
    <DropDownReactLink key="edit" text="Edit Schedule" to={`/maintenance/schedules/${schedule.id}/edit`} />,
    <DropdownDivider key="divider" />,
    <DropDownReactLink
      key="duplicate"
      text="Duplicate"
      to={`/maintenance/schedules/${schedule.id}/edit?duplicate=true`}
    />,
    <DropdownActionItem key="delete" text="Delete" onClick={() => setShowDelete(true)} />,
  ];

  if (nextOccurrence !== null) {
    if (schedule.is_active) {
      actionsBarItems.unshift(
        <DropdownActionItem key="pause" text="Pause Schedule" onClick={() => setShowPauseConfirm(true)} />
      );
    } else {
      actionsBarItems.unshift(
        <DropdownActionItem key="resume" text="Resume Schedule" onClick={() => resumeSchedule()} />
      );
    }
  }

  return (
    <>
      <MaintenanceDelete schedule={schedule} show={showDelete} setShow={setShowDelete} />
      <MaintenancePauseConfirmation schedule={schedule} show={showPauseConfirm} setShow={setShowPauseConfirm} />
      <QuickActionsBar
        id={`schedule-actions-${schedule.id}`}
        actions={[<DropdownAction id={`schedule-dropdown-${schedule.id}`} items={actionsBarItems} />]}
      />
    </>
  );
};
